module.exports = __webpack_public_path__ + "static/media/m_beard_stubble_oval_hazel.059131cc.png";